import { useAuth } from '../AuthProvider'
import { Navigate } from 'react-router-dom'
import { FullScreenLoader } from '../routes/FullScreenLoader'

export const AuthCallback = () => {
  const { isAuthorized, isAuthorizeLoading } = useAuth()
  if (isAuthorizeLoading) return <FullScreenLoader />
  return <Navigate to={isAuthorized ? '/dashboard' : '/auth'} replace />
}
